<template>
  <div :class="'p10 container-' + container">
    <h2 class="title" v-show="hide_title != true">{{title}}</h2>
    <div class="ck-content rich-text" v-html="content"></div>
  </div>
</template>

<script>

export default {
  name: "PageContent",
  components: {
  },
  props: ["page_key", "container", "hide_title"],
    data() {
      return {
          title:"",
          content:"",
      }
    },
  methods: {
  },
    created() {
      this.$toast.loading("加载中...");
      this.$http.get(`pages/${this.page_key}`)
          .then(({data}) => {
              this.$toast.hide();
              this.content = data.content;
              this.title = data.title;
          });
    },
};
</script>

<style lang="scss" scoped>
  .container-landscape {
    padding: 25px 20px 20px;
  }
  h2.title {
    /*line-height: 60px;*/
    margin-top: 10px;
    margin-bottom: 40px;
    color: #111a34;
    font-size: 60px;
    font-weight: bold;
    line-height: 1.5;
  }
  .container-page {
    padding: 20px 30px;
  }
</style>
